import { BONUS_COVERS } from './assets'

export type Bonus = {
  number: string
  title: string
  body: string
  /** Mockup del bonus. null = card de portada diseñada en la landing. */
  cover: string | null
  meta: string
}

/** Los 5 bonus reales del pack (DPS45 - Bonus.docx). */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Printable Card Deck',
    body: 'All 129 Experiment Cards as summary cards — name, grade, offer line and closing question, color-coded by family. Print and cut them, or keep them on a tablet, so you never flip through 300 pages mid-session.',
    cover: BONUS_COVERS['01'],
    meta: 'Printable · 129 cards',
  },
  {
    number: '02',
    title: 'See One Session, Start to Finish',
    body: 'A 50-minute session told minute by minute: what emerged, which figure was chosen, which card was offered at what grade, what the therapist said and how it closed — with margin notes. A composite case, no real client data.',
    cover: BONUS_COVERS['02'],
    meta: 'Walk-through · ~4 pages',
  },
  {
    number: '03',
    title: 'The 7-Day Adoption Plan',
    body: 'Which volume and which pages to open each day of your first week, so you get to know the library without feeling buried in it. One page a day and a 7-box checklist.',
    cover: BONUS_COVERS['03'],
    meta: 'Plan · ~9 pages',
  },
  {
    number: '04',
    title: 'The Therapist’s Pre-Session Routine',
    body: 'A five-minute routine to arrive present before you offer anything: grounding and a check of what you bring into the room. Plus a one-minute version for between clients and a pocket card.',
    cover: BONUS_COVERS['04'],
    meta: 'Routine · ~5 pages',
  },
  {
    number: '05',
    title: 'Gestalt in Short and Integrative Sessions',
    body: 'How to bring a Gestalt experiment into 20-minute sessions, brief counseling or integrative services without changing your model — with a table of the cards that fit in 20 minutes.',
    cover: BONUS_COVERS['05'],
    meta: 'Guide · ~10 pages',
  },
]
